export const LOAD_CART = "LOAD_CART";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const UPDATE_CART = "UPDATE_CART";
export const GET_TIME_SLOTS = "GET_TIME_SLOTS";
export const SET_TIME_SLOT = "SET_TIME_SLOT";
export const SET_DELIVERY_DATE = "SET_DELIVERY_DATE";
export const SET_TIME_SLOT_TIME = "SET_TIME_SLOT_TIME";
export const GET_RESTURENT_AVAILABILITY = "GET_RESTURENT_AVAILABILITY";